import { ArrowLeftOutlined } from "@ant-design/icons";
import UserIntro from "../ProfileSetup/UserIntro";
import SocialIcons from "../SourceConnector/OnboardingConnectSources";
import { Fragment, useState, useEffect, useMemo } from "react";
import { Button, Col, Row } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import LanguageSwitcher from "src/components/common/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/hooks/UseLanguage";
import "./OnboardignSidebar.scss";

export default function Sidebar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useLanguage(); // Initialize RTL support
  const steps = useMemo(
    () => [
      {
        id: 1,
        heading: t("onboardingSidebar.headingWelcome"),
        name: t("onboardingSidebar.stepBasicInfo"),
        component: UserIntro,
        path: "basic-information",
      },
      {
        id: 2,
        heading: t("onboardingSidebar.headingConnect"),
        name: t("onboardingSidebar.stepConnectSources"),
        component: SocialIcons,
        path: "connect-sources",
      },
    ],
    [t]
  );
  const [currentStep, setCurrentStep] = useState(0);
  const [, setCompletedSteps] = useState(Array(steps.length).fill(false));
  const [showMagicScreen, setShowMagicScreen] = useState(false);
  const [connectedConnectors, setConnectedConnectors] = useState<string[]>([]);

  const location = useLocation();

  useEffect(() => {
    const storedStep = localStorage.getItem("currentStep");
    if (storedStep !== null) {
      setCurrentStep(parseInt(storedStep, 10));
    }
  }, []);

  // useEffect(() => {
  //   // Save the currentStep to localStorage whenever it changes
  //   localStorage.setItem("currentStep", currentStep.toString());
  // }, [currentStep]);

  useEffect(() => {
    const state = location.state as { currentStep?: number } | null;
    if (state?.currentStep !== undefined) {
      setCurrentStep(state.currentStep); 
    }
  }, [location]);

  const nextStep = (isValid: boolean) => {
    if (currentStep < steps.length && isValid) {
      // Move to the next step if valid
      setCompletedSteps(prev => {
        const updatedSteps = [...prev];
        updatedSteps[currentStep] = true;
        return updatedSteps;
      });
      //setIsPaymentStep(false); 
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
  };

  const handleDoneClick = () => {
    setShowMagicScreen(true);
  };

  if (showMagicScreen) {
    navigate("/welcome-to-datatram/data-loading");
  }

  const CurrentComponent = steps[currentStep]?.component;

  const handleConnectionCreated = (connectorName: string) => {
    setConnectedConnectors(prev => {
      const updatedConnectors = [...prev, connectorName]; 
      return updatedConnectors;
    });
  };

  const isSourceConnectorStep = steps[currentStep]?.id === 2;

  useEffect(() => {
    if (isSourceConnectorStep) {
      navigate("/welcome-to-datatram/connect-sources" , { state: { from: "basic-information" } });
    }
  }, [isSourceConnectorStep, navigate]);

  return (
    <Fragment>
      <Row gutter={[16, 16]}>
        <Col
          xs={24}
          sm={24}
          md={8}
          lg={6}
          xl={4}
          xxl={4}
          className="stepbody"
        >

          {/*   {currentStep > 0 && (
              <Button className="prebutton sidebar-back" onClick={prevStep}>
                <span className="button-icon">
                  <ArrowLeftOutlined />
                </span>
              </Button>
            )} */}
          <div className="sidebar-header">
            <p className="stepheading">{steps[currentStep]?.heading}</p>
            <LanguageSwitcher />
          </div>
          <div className="steps-list-section">
            <ul>
              {steps?.map((step, index) => (
                <li
                  key={index}
                  className={`step-item ${
                    index === currentStep ? "active-step" : ""
                  }`}
                >
                  <div className="step-icon">
                    {index <
                    currentStep /*|| (index === 1 && isPaymentStep) */ ? (
                      <img
                        src="/images/tick.svg"
                        alt="Completed"
                        className="tick-icon"
                      />
                    ) : (
                      <div
                        className={`steps-circle ${
                          index === currentStep ? "active-step-circle" : ""
                        }`}
                      >
                        {index + 1}
                      </div>
                    )}
                  </div>
                  <span
                    className={`step-name ${
                      index === currentStep ? "active-step-name" : ""
                    }`}
                  >
                    {step.name}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="onboarding-sidebar-footer">
            <Button
              className="nextbutton"
              onClick={() => {
                if (steps[currentStep].id === 1) {
                  (document.getElementById("nextBtn") as HTMLElement).click();
                } else if (steps[currentStep].id === steps.length) {
                  handleDoneClick();
                } else {
                  nextStep(true);
                }
              }}
              disabled={
                // (steps[currentStep].id === 2 &&
                //   !payNowClicked &&
                //   !isPaymentStep) ||
                steps[currentStep].id === 2 && connectedConnectors.length === 0 
              }
            >
              {currentStep === steps.length - 1
                ? t("onboardingSidebar.done")
                : t("onboardingSidebar.next")}
            </Button>
          </div>
        </Col>

        <Col xs={24} sm={24} md={16} lg={18} xl={18} xxl={18}>
          {isSourceConnectorStep ? (
            <SocialIcons
              onNext={(isValid: boolean) => nextStep(isValid)}
              onBack={
                steps[currentStep].component === UserIntro
                  ? prevStep
                  : () => {
                    }
              }
              // payNowClicked={confirmPayment}
              onConnectionCreated={handleConnectionCreated} 
              // {...(CurrentComponent === PaymentConfirmation
              //   ? { handlePaymentConfirmation }
              //   : {})}
            />
          ) : (
            <CurrentComponent
              onNext={(isValid: boolean) => nextStep(isValid)}
              onBack={() => {
                if (currentStep > 0) {
                  navigate(
                    `/welcome-to-datatram/${steps[currentStep - 1].path}`
                  );
                }
              }}
            />
          )}
        </Col>
      </Row>
      <Outlet />
    </Fragment>
  );
}
